import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';

export default class FieldFile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: {},
        };

        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);

    }

    onChange(file) {

        this.setState({value: file.length === 0 ? {} : file[0]}, () =>{
            if (this.props.option.onChange) {
                this.props.option.onChange(file.length === 0 ? '' : file[0].name);
            }
            if (this.props.option.onChangeValue) {
                this.props.option.onChangeValue(file.length === 0 ? undefined : file[0]);
            }
        });
    }


    onClick(e) {
        e.target.value = '';
        if (this.props.option.onClick) {
            this.props.option.onClick(e);
        }
    }

    getValue() {
        return this.state.value;
    }

    render() {

        return (
            <label>
                {this.props.children}
                <input type="file" className='hidden' onChange={e => this.onChange(e.target.files)} onClick={this.onClick}/>
            </label>
        );
    }

}
